/* eslint-disable import/no-anonymous-default-export */
import Workflows from "./Workflows";
import Placeholders from "./Placeholders";
export default {
    id: 108,
    title: 'Payments',
    path: 'payments',
    icon: "flaticon2-tag",
    workflows: Workflows,
    placeholders: Placeholders,
};